export default __webpack_public_path__ + "static/media/smartphone.59fc76be.svg";